import React, { useState } from 'react';
import "./mainPage.css";
import NavBar from '../../components/navbar/NavBar';
import { useNavigate } from "react-router-dom";
import CapacityRoadMap from '../capacityRoadMap/capacityRoadMap'
import * as XLSX from 'xlsx';
import UploadExcel from '../uploadExcel/uploadExcel';
import uploadImg from './../../../assets/upload.png';
import downloadImg from './../../../assets/downloadTemplate.png';
import axios from 'axios';
import baseConfig from '../../../config/config';
import { useSelector } from 'react-redux';
import MasterTableTab from '../masterTableTab/MasterTableTab';
import { fetchGPUData } from '../../../redux/actions/actions';
import { useDispatch } from "react-redux";
import { getUniqueParam } from '../../components/helpers';
import Footer from '../../components/footer/Footer';
const tabsData = [
    { label: 'Capacity Roadmap', content: <CapacityRoadMap /> },
    { label: 'Capacity Roadmap Master Table', content: <MasterTableTab /> },
];

const MainPage = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(sessionStorage.getItem("tab") || 0);
    const [isOpen, setIsOpen] = useState(false);
    const [isRegionOpen, setIsRegionOpen] = useState(false);
    const dispatch = useDispatch();
    const [successfulLogin, setSuccessfulLogin] = useState(false);
 
    const isGPUDataLoading = useSelector(store => store.GPUData.isGPUDataLoading);
    const isGPUDataLoaded = useSelector(store => store.GPUData.isGPUDataLoaded);
    const GPUData = useSelector(store => store.GPUData.GPUData !== undefined ? store.GPUData.GPUData : []);

    const [openGPU, setOpenGPU] = useState(false);
    const [openUploadPopup, setOpenUploadPopup] = useState(false)
    const [isContributor, setIsContributor] = useState(false)

    function showToast(message) {
        const toaster = document.createElement('div');
        toaster.className = 'toaster danger-toaster';
        toaster.style.position = 'fixed';
        toaster.style.top = '5%';
        toaster.style.left = '50%';
        toaster.style.transform = 'translateX(-50%)';

        toaster.style.height = 'fit-content'; 
        toaster.style.maxWidth = '300px';

        toaster.innerText = message;



        document.body.appendChild(toaster);
        setTimeout(() => {
            toaster.style.display = 'none'; 
        }, 5000);
    }
    const openGpu = () => {
        setOpenGPU(!openGPU);
    };
    const handleTabClick = (index) => {
        const url = new URL(window.location.href);
        const uniqueParam = getUniqueParam();
        if (index === 1) {
            const gpuFilter = JSON.parse(sessionStorage.getItem('gpuFilter'))
            if (gpuFilter !== null) {
                var tempvar = JSON.stringify(gpuFilter.filter((obj) => obj.property !== "gpumaster"))
                tempvar = encodeURI(tempvar)
                // url.searchParams.set("key", tempvar);
            } else {
                url.pathname = `/Home`;
                url.search = `?visit=${uniqueParam}`
            }
        } else {
            dispatch(fetchGPUData())
            url.pathname = `/Home`;
            url.search = `?visit=${uniqueParam}`

        }
        setActiveTab(index);
        sessionStorage.setItem('tab', index)
        window.history.pushState({}, '', url.href);
    };
    const openPopup = () => {
        setIsOpen(!isOpen);
    };

    const openRegionPopup = () => {
        setIsRegionOpen(!isRegionOpen);
    };

    // Get the URL
    var url = new URL(window.location.href);

    // Extract the filter array from the URL
    var filterArray = extractFilterArray(url);

    function extractFilterArray(url) {
        let currentURL = new URL(url)
        let filter = null;
        if (currentURL.searchParams.has('key')) {
            filter = currentURL.searchParams.get("key")
            filter = decodeURI(filter)
            filter = filter.replace("?key=", "/")
            return JSON.parse(filter);

        }

        else {
            return JSON.stringify([]);
        }
    }

    const checkUrl = async () => {
        try {
            if (sessionStorage.getItem('userToken')) {
                setSuccessfulLogin(true)
            }
            else {
                setSuccessfulLogin(false);
                if (!sessionStorage.getItem('href')) {
                    sessionStorage.setItem("href", window.location.href)
                    navigate('/')
                }
            }
        }
        catch (error) {
            setSuccessfulLogin(false);
            if (!sessionStorage.getItem('href')) {
                sessionStorage.setItem("href", window.location.href)
                navigate('/')
            }
        }
    }

    const downloadTemplate = async () => {
        const url = sessionStorage.getItem('tab') === '1' ? '?TemplateType=ManagedTemplate' : '?TemplateType=EARequestTemplate'
        const config = {
            headers: {
                'content-type': 'application/json',
                "serviceid": sessionStorage.getItem("userToken")
            }
        };
        axios.get(baseConfig.apiBaseUrl + '/utility/table/template/download', config)
            .then(response => {
                if (response.status === 200) {
                    try {
                        window.open(response.data, '_blank');
                        window.URL.revokeObjectURL(response.data);
                    } catch (error) {
                        console.error('Error downloading Excel file:', error);
                    }
                }

            })
            .catch(function (error) {
                console.error(error);

                if (error.response.status === 401) {
                    navigate("/errorPage");
                }
            });
    };


    const exportToExcel = (gpuType, tableIndex) => {
        const workbook = XLSX.utils.book_new();
        const link = document.createElement('a');
        const combinedData = [];
        if (gpuType === "All") {
            link.download = `All_GPU_Capacity.xlsx`;
            combinedData.push(["All GPU Capacity Data"]);
 
            Object.keys(GPUData).forEach(gpu => {
                const gpuData = GPUData[gpu];
                if (gpuData.length > 0) {
                    combinedData.push([`${gpu} Capacity Data`]);
                    
                    const displayHeaders = ["Region", "Total GPUs", "GPUs Earmarked", "GPUs Committed", "GPUs Allocated", "GPUs Available"];
                    const dataKeys = ["Region", "Total", "GPUsEarmarked", "GPUsCommitted", "GPUsAllocated", "GPUsAvailable"];
                    
                    combinedData.push(displayHeaders);
                    
                    const dataRows = gpuData.map(item => {
                        return dataKeys.map(key => item[key]);
                    });
                    combinedData.push(...dataRows);
                    const addTotalRow = (tableData) => {
                        const totalRow = ["Total"];
                        dataKeys.slice(1).forEach(label => {
                            const sum = tableData.reduce((acc, item) => acc + (parseInt(item[label]) || 0), 0);
                            totalRow.push(sum);
                        });
                        return totalRow;
                    };
                    combinedData.push(addTotalRow(gpuData));
                    combinedData.push([]);
                }
            });
        } else {
            const filteredGPUData = GPUData[gpuType] || [];
            if (filteredGPUData.length === 0) {
                return;
            }
 
            link.download = `${gpuType}_Capacity.xlsx`;
            combinedData.push([`${gpuType} Capacity Data`]);
            const displayHeaders = ["Region", "Total GPUs", "GPUs Earmarked", "GPUs Committed", "GPUs Allocated", "GPUs Available"];
            const dataKeys = ["Region", "Total", "GPUsEarmarked", "GPUsCommitted", "GPUsAllocated", "GPUsAvailable"];
            
            combinedData.push(displayHeaders);
            
            const dataRows = filteredGPUData.map(item => {
                return dataKeys.map(key => item[key]);
            });
            combinedData.push(...dataRows);
            
            const addTotalRow = (tableData) => {
                const totalRow = ["Total"];
                dataKeys.slice(1).forEach(label => {
                    const sum = tableData.reduce((acc, item) => acc + (parseInt(item[label]) || 0), 0);
                    totalRow.push(sum);
                });
                return totalRow;
            };
            combinedData.push(addTotalRow(filteredGPUData));
        }
             
        const worksheet = XLSX.utils.aoa_to_sheet(combinedData);
        XLSX.utils.book_append_sheet(workbook, worksheet, `GPU Roadmap`);
        const excelFile = XLSX.write(workbook, { bookType: 'xlsx', type: 'base64' });
        link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${excelFile}`;
        link.click();
    };

    const closeUploadPopUpOpen = () => {
        setOpenUploadPopup(false)
    }

    const getFilters = async (uuid) => {
        if (uuid === "Home") {
            const currentTab = parseInt(sessionStorage.getItem("tab"));
            setActiveTab(currentTab);
        } else if (uuid) {
            const config = {
                headers: {
                    "content-type": "application/json",
                    serviceid: sessionStorage.getItem("userToken")
                },
            };
            let copyLinkFilters = {}
            try {
                const response = await axios.get(
                    baseConfig.apiBaseUrl + "/vanity/url/get/value?id=" + uuid,
                    config
                );
                if (response.status === 200) {
                    if (response.data) {

                        copyLinkFilters = JSON.parse(response.data);
                        var isAllowed = false;

                        if ((response.data.includes("ptuTriage") || response.data.includes("gpumaster")) && sessionStorage.getItem("AvailableRoles").includes(","))
                            isAllowed = true;

                        else if ((response.data.includes("ptuTriage") || response.data.includes("gpumaster")) && !sessionStorage.getItem("AvailableRoles").includes("EarlyAccessPreview"))
                            isAllowed = true;

                        if (!isAllowed) {
                            showToast("You don’t have access to this tab. Please write to Pia Rossi to request access.");
                            navigate("/errorPage");
                        }
                    } else {
                        showToast("The link you have copied seems to be incorrect. Please check and try again.");
                        navigate("/errorPage");

                    }
                }
            } catch (error) {
                // setPreFilterSelected(null);
                console.error(error);
                if (error.response.status === 401) {
                    navigate("/errorPage");
                }
            }
            filterArray = copyLinkFilters
            if (copyLinkFilters) {
                if (filterArray !== null && Array.isArray(filterArray)) {

                    for (var i = 0; i < filterArray.length; i++) {
                        if (filterArray[i].property === 'gpumaster') {
                            sessionStorage.setItem('tab', '1');
                            sessionStorage.setItem('copyLinkuuid', uuid)
                            setActiveTab(1)
                            sessionStorage.setItem("gpuFilter", JSON.stringify(filterArray))
                            break; 
                        }
                    }
                } else {
                    console.error('Invalid filterArray format:', filterArray);
                }
            }
        }
    }

    React.useEffect(() => {
        checkUrl();
        const uuid = window.location.pathname.split('/').pop();
        console.log("uuid ==> ", uuid);
        getFilters(uuid)
        const activeRole = sessionStorage.getItem("ActiveRole");

        if (activeRole) {
            setIsContributor(activeRole.includes("Contributor"));
        }
        const currentTab = parseInt(sessionStorage.getItem('tab') || '0');
        setActiveTab(currentTab);
        sessionStorage.setItem('tab', currentTab.toString());
    }, []);
    React.useEffect(() => {
        if (!isGPUDataLoaded) {
            dispatch(fetchGPUData());
        }
    }, [isGPUDataLoading])

    return (
        <>
            {successfulLogin && (
                <>
                    <NavBar checkUrl={checkUrl}></NavBar>
                    <div className='rightDiv'>
                        <ul className="tab-list">
                            {tabsData.map((tab, index) => (
                                <li
                                    key={index}
                                    className={sessionStorage.getItem("tab") == index ? 'active-tab' : ''}
                                    onClick={() => handleTabClick(index)}
                                >
                                    {tab.label}
                                </li>
                            ))}
                        </ul>

                        {activeTab === 0 ? (
                            <ul className="tab-list" style={{ display: 'flex', gap: '10px', listStyle: 'none', padding: '0' }}>
                                <li style={{ padding: '5px 0px' }}>
                                    <div
                                        className="tabButton"
                                        onClick={() => exportToExcel("All", -1)}
                                        style={{ margin: '0' }} // Remove negative margin
                                    >
                                        <span style={{ color: '#4B81FF' }}></span>
                                        Export All Tables to Excel
                                    </div>
                                </li>
                                {isContributor && (
                                    <li style={{ padding: '5px 0px' }}>
                                        <div
                                            className="tabButton"
                                            onClick={openPopup}
                                            style={{ margin: '0' }}
                                        >
                                            <span style={{ color: '#4B81FF' }}>+</span> Add New Region
                                        </div>
                                    </li>
                                )}
                                {isContributor && (
                                    <li style={{ padding: '5px 10px 5px 0px' }}>
                                        <div
                                            className="tabButton"
                                            onClick={openRegionPopup}
                                            style={{ margin: '0' }}
                                        >
                                            <span style={{ color: '#4B81FF' }}></span> Remove Region
                                        </div>
                                    </li>
                                )}
                            </ul>
                        ) : isContributor && (
                            <ul className="tab-list">
                                <li style={{ padding: '5px 20px' }}>
                                    <div
                                        className='tabButton'
                                        onClick={downloadTemplate}
                                        style={{ marginRight: '-20px' }}
                                    >
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                            <img
                                                src={downloadImg}
                                                alt="Filter Icon"
                                                style={{ height: '15px', width: '15px', marginRight: '10px' }}
                                            />
                                            Download Template
                                        </span>
                                    </div>
                                </li>
                                <li style={{ padding: '5px 20px' }}>
                                    <div
                                        className='tabButton'
                                        onClick={() => setOpenUploadPopup(true)}
                                        style={{ margin: '0px' }}
                                    >
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                            <img
                                                src={uploadImg}
                                                alt="Filter Icon"
                                                style={{ height: '15px', width: '15px', marginRight: '10px' }}
                                            />
                                            Upload Excel
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        )}

                    </div>
                    <div style={{ width: '100%', textAlign: 'right', fontSize: '10px', right: '20px', position: 'relative', padding: '10px 10px 0 0' }}>
                        {isContributor ? (
                            <span>
                                Not seeing a region? Need help? Send mail to Pia Rossi (Pia.Rossi@microsoft.com)
                            </span>
                        ) : (
                            <span>
                                Want to request for access? <a href="mailto:Pia.Rossi@microsoft.com">Contact Us</a>
                            </span>
                        )}
                    </div>

                    <div className="tab-content main-tab">
                        {activeTab === 0 ? (
                            <CapacityRoadMap
                                isOpen={isOpen}
                                openPopup={openPopup}
                                isRegionOpen={isRegionOpen}
                                openRegionPopup={openRegionPopup}
                                userRole={sessionStorage.getItem("ActiveRole")}
                                openGPU={openGPU}
                                openGpu={openGpu}
                                exportToExcel={exportToExcel}
                            />
                        ) :
                            <MasterTableTab
                                setOpenUploadPopup={setOpenUploadPopup}
                                downloadTemplate={downloadTemplate}
                            />
                        }
                    </div>

                    {openUploadPopup && (
                        <>
                            <UploadExcel closeUploadPopUpOpen={closeUploadPopUpOpen}></UploadExcel>
                            <div className="modal-backdrop"></div>
                        </>
                    )}
                    <Footer />
                </>
            )
            }
        </>
    );

};

export default MainPage;
